function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "#F5F5F5"
}, React.createElement("path", {
  d: "M1411 2845.326c28.61-28.61 28.896-74.818.858-103.78l-.534-.544.002-.002-.326-.326-.002.002-.544-.534c-28.67-27.755-74.238-27.755-102.908 0l-.872.858L1411 2845.326z",
  transform: "translate(-1306 -2719)"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 127,
    height: 127,
    viewBox: "0 0 127 127"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/figure-2.61e10976.svg";
export { SvgComponent as ReactComponent };